import { Service, inject } from '@angular/core'
import { CreateEventBlueprintBody } from '@seiri/shared/common'
import { ApiService } from '../api.service'

@Service()
export class ManageEventBlueprintApiService {
  private readonly api = inject(ApiService)

  createEventBlueprint(entityId: string, body: CreateEventBlueprintBody, init?: RequestInit) {
    return this.api.protectedFetchJson<object>(`manage/entities/${entityId}/event-blueprints`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...init,
    })
  }
}
